import { css } from "@emotion/react";
import React, { memo } from "react";
import { menuList } from "../../../consts";
import { colors } from "../../../style/colors";
import { HashLink } from "react-router-hash-link";

const Header: React.FC = () => {
  const scrollWithOffset = (el: HTMLElement, offset: number) => {
    const elementPosition = el.offsetTop - offset;
    window.scroll({
      top: elementPosition,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <header
      css={css`
        position: sticky;
        top: 0;
        background-color: ${colors.mainColor};
        z-index: 100;
        padding: 5px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      `}
    >
      <h1
        css={css`
          max-width: 52px;
        `}
      >
        <img src="/img/header_logo.png" alt="3600YAKO" />
      </h1>
      <div
        css={css`
          display: flex;
          gap: 18px;
          & > a {
            color: #fff;
            text-decoration: none;
            font-family: "Bebas Neue", cursive;
            font-weight: 300;
            font-size: 18px;

            &:hover {
              text-decoration: underline;
            }
          }
        `}
      >
        {menuList.map((menu, i) => (
          <HashLink
            key={i}
            smooth
            to={`/#${menu.id}`}
            scroll={(el) => scrollWithOffset(el, 150)}
          >
            <span>{menu.label}</span>
          </HashLink>
        ))}
      </div>
    </header>
  );
};

export default memo(Header);
